export const isLoadingFirmwareListSelector = (state) => state?.firmware?.isLoading
export const firmwareListSelector = (state) => state?.firmware?.list
export const firmwareDropdownListSelector = (state) => state?.firmware?.list?.map(item => ({label: item, value: item}))

export const isLoadingFirmwareFilteredListSelector = (state) => state?.firmware?.filteredListIsLoading
export const firmwareFilteredListSelector = (state) => state?.firmware?.filteredList
